import { render, staticRenderFns } from "./NewWatchModal.vue?vue&type=template&id=0517c4dd&scoped=true&"
import script from "./NewWatchModal.vue?vue&type=script&lang=js&"
export * from "./NewWatchModal.vue?vue&type=script&lang=js&"
import style1 from "./NewWatchModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0517c4dd",
  null
  
)

export default component.exports